export default (el, params, cb) => {
  const observer = new window.MutationObserver(cb)

  observer.observe(el, params)

  return {
    destroy: () => {
      observer.disconnect()
    }
  }
}
